var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-loading d-flex justify-content-center align-items-center"},[_c('img',{staticClass:"animate-flicker",attrs:{"width":"50px","src":_vm.loading_gif,"alt":"Loading..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }